import { ThemeType } from '@campaign-portal/namespace/entities/portals/specs';

const DEGREES_IN_CIRCLE = 360;
const GOLDEN_ANGLE = 137.508;
const HSV_HUE_SEGMENTS = 6;
const LIGHTNESS_DARK = 65;
const LIGHTNESS_LIGHT = 45;
const RGB_MAX_VALUE = 255;
const SATURATION_DARK = 70;
const SATURATION_LIGHT = 65;

const HASH_INIT = 5381;
const HASH_SHIFT = 5;
const HSV_CASE_3 = 3;
const HSV_CASE_4 = 4;
const HSV_CASE_5 = 5;

export function hsvToRgb(h: number, s: number, v: number): { r: number; g: number; b: number } {
	let r = 0,
		g = 0,
		b = 0;

	const i = Math.floor(h * HSV_HUE_SEGMENTS);
	const f = h * HSV_HUE_SEGMENTS - i;
	const p = v * (1 - s);
	const q = v * (1 - f * s);
	const t = v * (1 - (1 - f) * s);

	switch (i % HSV_HUE_SEGMENTS) {
		case 0:
			r = v;
			g = t;
			b = p;
			break;
		case 1:
			r = q;
			g = v;
			b = p;
			break;
		case 2:
			r = p;
			g = v;
			b = t;
			break;
		case HSV_CASE_3:
			r = p;
			g = q;
			b = v;
			break;
		case HSV_CASE_4:
			r = t;
			g = p;
			b = v;
			break;
		case HSV_CASE_5:
			r = v;
			g = p;
			b = q;
			break;
	}

	return {
		r: Math.round(r * RGB_MAX_VALUE),
		g: Math.round(g * RGB_MAX_VALUE),
		b: Math.round(b * RGB_MAX_VALUE),
	};
}

function hash32(s: string): number {
	let h = HASH_INIT;
	for (let i = 0; i < s.length; i++) {
		h = ((h << HASH_SHIFT) + h) ^ (s.codePointAt(i) ?? 0);
	}
	return h >>> 0;
}

export function lineColor(
	keyOrIndex: string | number,
	themeType: ThemeType = 'light',
	paletteLight: string[] = [],
	paletteDark: string[] = []
): string {
	const isDark = themeType === 'dark';
	const pal = isDark ? paletteDark : paletteLight;

	const idx =
		typeof keyOrIndex === 'number' && Number.isFinite(keyOrIndex) && keyOrIndex >= 0
			? Math.floor(keyOrIndex)
			: hash32(String(keyOrIndex));

	if (pal.length > 0) {
		return pal[idx % pal.length];
	}

	const hue = (idx * GOLDEN_ANGLE) % DEGREES_IN_CIRCLE;
	const sat = isDark ? SATURATION_DARK : SATURATION_LIGHT;
	const light = isDark ? LIGHTNESS_DARK : LIGHTNESS_LIGHT;
	return `hsl(${hue} ${sat}% ${light}%)`;
}
